module.exports = __webpack_public_path__ + "static/media/tw.5a2b4914.svg";